module.exports = __webpack_public_path__ + "img/maisonette-10.a280121a.webp";